var FIRST = 1;
export default {
  name: 'SelectPagePagination',
  render: function render(h) {
    var _this = this;

    var list = [];
    /**
     * 计算页码
     */

    var genItem = function genItem(classes, title, action) {
      return h('li', {
        class: classes,
        attrs: {
          title: title
        }
      }, [h('a', {
        attrs: { href: 'javascript:void(0);' },
        on: { click: function click() {
            return _this.switchPage(action);
          } }
      }, [h('i', { class: 'sp-iconfont sp-icon-' + action })])]);
    };
    list.push(genItem({ 'sp-disabled': this.value === FIRST }, this.i18n.first, 'first'));
    list.push(genItem({ 'sp-disabled': this.value === FIRST }, this.i18n.prev, 'previous'));
    list.push(genItem({ 'sp-disabled': this.value === this.totalPage, 'sp-right': true }, this.i18n.last, 'last'));
    list.push(genItem({ 'sp-disabled': this.value === this.totalPage, 'sp-right': true }, this.i18n.next, 'next'));

    return h('div', { class: 'sp-pagination' }, [h('div', { class: 'sp-page-info' }, [h('span', this.pageInfo.page_num_text), h('span', { style: { 'color': '#3179F5', 'font-weight': 'bold' } }, this.pageInfo.page_num), h('span', this.pageInfo.page_count_text), h('span', { style: { 'color': '#3179F5', 'font-weight': 'bold' } }, this.pageInfo.page_count), h('span', { style: { 'margin-right': '5px' } }, this.pageInfo.page_count_label), h('span', this.pageInfo.row_count_text), h('span', { style: { 'color': '#3179F5', 'font-weight': 'bold' } }, this.pageInfo.row_count), h('span', this.pageInfo.row_count_label)]), h('ul', list)]);
  },

  props: {
    value: {
      type: Number,
      default: 1
    },
    pageSize: Number,
    totalRow: Number
  },
  inject: ['i18n'],
  data: function data() {
    return {
      lastNumber: -1
    };
  },

  computed: {
    pageInfo: function pageInfo() {
      return {
        page_num_text: '第',
        page_num: this.value,
        page_count_text: ' / ',
        page_count: this.totalPage,
        page_count_label: ' 页 ',
        row_count_text: '( 共 ',
        row_count: this.totalRow,
        row_count_label: ' 条记录 )'

        // this.i18n.page_info
        //    .replace('page_num', this.value)
        //      .replace('page_count', this.totalPage)
        //      .replace('row_count', this.totalRow)
      };
    },
    totalPage: function totalPage() {
      return Math.ceil(this.totalRow / this.pageSize);
    }
  },
  methods: {
    getPageNumber: function getPageNumber(action) {
      switch (action) {
        case 'first':
          return FIRST;
        case 'previous':
          return this.value > FIRST ? this.value - 1 : FIRST;
        case 'next':
          return this.value < this.totalPage ? this.value + 1 : this.totalPage;
        case 'last':
          return this.totalPage;
      }
    },
    switchPage: function switchPage(action) {
      var pageNumber = this.getPageNumber(action);
      //if (pageNumber === this.lastNumber) return
      if (pageNumber) this.$emit('input', pageNumber);
      this.lastNumber = pageNumber;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/components/Pagination.js
// module id = 13
// module chunks = 0